// Copyright (C) Lembani Sakala - All rights reserved.
// Lembani Sakala.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.

import React from 'react';

import { RootState } from '../../../app/store';
import { useAppSelector } from '../../../app/hooks';

import avatar from '../../../images/user.png';
import { FaUser, FaEnvelope, FaPhone, FaMapMarkerAlt, FaEdit } from 'react-icons/fa';

export const UserProfile = () => {
  const user = useAppSelector((state: RootState) => state.user.userInfo);

  return (
    <div className='profile-page'>
      <h2 className='profile-heading'>My Profile</h2>
      <div className='profile-card'>
        <div className='profile-header'>
          <div className='profile-avatar-lg'>
            <img src={avatar} alt='Profile' />
          </div>
          <div className='profile-header-info'>
            <h3>{user?.firstname} {user?.lastname}</h3>
            <span className='profile-member-badge'>Member</span>
          </div>
        </div>
        <div className='profile-details'>
          <div className='profile-detail-item'>
            <div className='profile-detail-icon'><FaUser /></div>
            <div className='profile-detail-content'>
              <span className='profile-detail-label'>Full Name</span>
              <span className='profile-detail-value'>{user?.firstname} {user?.lastname}</span>
            </div>
          </div>
          <div className='profile-detail-item'>
            <div className='profile-detail-icon'><FaEnvelope /></div>
            <div className='profile-detail-content'>
              <span className='profile-detail-label'>Email</span>
              <span className='profile-detail-value'>{user?.username}</span>
            </div>
          </div>
          <div className='profile-detail-item'>
            <div className='profile-detail-icon'><FaPhone /></div>
            <div className='profile-detail-content'>
              <span className='profile-detail-label'>Phone</span>
              <span className='profile-detail-value'>{user?.phone}</span>
            </div>
          </div>
          <div className='profile-detail-item'>
            <div className='profile-detail-icon'><FaMapMarkerAlt /></div>
            <div className='profile-detail-content'>
              <span className='profile-detail-label'>Address</span>
              <span className='profile-detail-value'>—</span>
            </div>
          </div>
        </div>
        <button className='profile-edit-btn disabled'>
          <FaEdit className='me-2' /> Edit Profile
        </button>
      </div>
    </div>
  );
};
